// 深拷贝
export function deepCopy (source) {
  var temp = JSON.stringify(source)
  return JSON.parse(temp)
}

// class 操作
function hasClass (obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

export function addClass (obj, cls) {
  if (!this.hasClass(obj, cls)) {
    obj.className += ' ' + cls
  }
}

export function removeClass (obj, cls) {
  if (hasClass(obj, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    obj.className = obj.className.replace(reg, ' ')
  }
}

// 字符串统计数量 不能改变原型
export function gblen (value) {
  var len = 0
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
      len += 2
    } else {
      len++
    }
  }
  return len
}

// 字符串清除空格  不能改变原型
export function trimStr (value) {
  let str
  str = value.replace(/(^\s*)|(\s*$)/g, '')
  return str
}

/* 动态加载外部链接 */
export function loadJs (url, callback) {
  let script = document.createElement('script')
  script.type = 'text/javascript'
  if (typeof (callback) !== 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null
          callback()
        }
      }
    } else {
      script.onload = function () {
        callback()
      }
    }
  } else {
    callback && callback(new Error())
  }
  script.src = url
  document.body.appendChild(script)
}

/* 格式化字符串保存数据库 */
export function formatTextarea (str) {
  var reg = new RegExp('\\n', 'g')
  var regSpace = new RegExp(' ', 'g')
  str = str.replace(reg, '<br>')
  str = str.replace(regSpace, '&nbsp;')
  return str
}

/* 恢复字符串放入textarea */
export function unformatTextarea (str) {
  var reg = new RegExp('<br>', 'g')
  var regSpace = new RegExp('&nbsp;', 'g')
  str = str.replace(reg, '\n')
  str = str.replace(regSpace, ' ')
  return str
}



// WEBPACK FOOTER //
// ./src/common/utils/common.js